import { gql } from '@apollo/client';

/** 编辑字段抽屉数据：与列表类型独立，字段与后端 OpsTmsTaskDetailType 一一对应 */
export type TmsTaskDetailItem = {
  id: number;
  taskStatus: number | null;
  isDeleted: boolean;
  createdAt: string | null;
  updatedAt: string | null;
  /** 起点/终点时区（IANA），前端据此把 UTC 时间点换算为本地日期/时间；缺失为 null */
  originZone: string | null;
  destinationZone: string | null;
  taskNumber: string | null;
  taskSource: number | null;
  taskType: number | null;
  businessType: number | null;
  taskDate: string | null;
  bolNumber: string | null;
  perVehicleCost: number | null;
  routeId: number | null;
  scheduleId: number | null;
  routeName: string | null;
  routeType: number | null;
  routeCode: string | null;
  warehouseId: number | null;
  planDepartureDate: string | null;
  planDepartureTime: string | null;
  planDepartureAt: string | null;
  actualDepartureDate: string | null;
  actualDepartureTime: string | null;
  actualDepartureAt: string | null;
  planArrivalDate: string | null;
  planArrivalTime: string | null;
  planArrivalAt: string | null;
  actualArrivalDate: string | null;
  actualArrivalTime: string | null;
  actualArrivalAt: string | null;
  carrierId: number | null;
  driverId: number | null;
  vehicleId: number | null;
  publishedAt: string | null;
  completedAt: string | null;
  completedDate: string | null;
  phoneNumber: string | null;
  trailerNumber: string | null;
  escortCount: number | null;
  gpsTracking: string | null;
  licensePlate: string | null;
  driverName: string | null;
  vehicleTypeId: number | null;
  remark: string | null;
  extExists: boolean;
  driver1Id: number | null;
  driver1Name: string | null;
  driver1PhoneNumber: string | null;
  driver2Id: number | null;
  driver2Name: string | null;
  driver2PhoneNumber: string | null;
  isBulkConsolidated: boolean | null;
  cancelReason: string | null;
};

export type TmsTaskDetailResponse = {
  opsToolTmsTaskDetail: TmsTaskDetailItem;
};

export const TMS_TASK_DETAIL = gql`
  query OpsToolTmsTaskDetail($taskId: Long!) {
    opsToolTmsTaskDetail(taskId: $taskId) {
      id
      taskStatus
      isDeleted
      createdAt
      updatedAt
      originZone
      destinationZone
      taskNumber
      taskSource
      taskType
      businessType
      taskDate
      bolNumber
      perVehicleCost
      routeId
      scheduleId
      routeName
      routeType
      routeCode
      warehouseId
      planDepartureDate
      planDepartureTime
      planDepartureAt
      actualDepartureDate
      actualDepartureTime
      actualDepartureAt
      planArrivalDate
      planArrivalTime
      planArrivalAt
      actualArrivalDate
      actualArrivalTime
      actualArrivalAt
      carrierId
      driverId
      vehicleId
      publishedAt
      completedAt
      completedDate
      phoneNumber
      trailerNumber
      escortCount
      gpsTracking
      licensePlate
      driverName
      vehicleTypeId
      remark
      extExists
      driver1Id
      driver1Name
      driver1PhoneNumber
      driver2Id
      driver2Name
      driver2PhoneNumber
      isBulkConsolidated
      cancelReason
    }
  }
`;

export type TmsTaskFieldOption = {
  value: number;
  label: string;
  phone?: string | null;
  routeName?: string | null;
  routeCode?: string | null;
  routeType?: number | null;
  startWarehouseId?: number | null;
  routeId?: number | null;
  carrierId?: number | null;
  centerWarehouseIds?: string[] | null;
  licensePlate?: string | null;
  vehicleTypeId?: number | null;
};

export type TmsTaskFieldOptionsResponse = {
  opsToolTmsTaskFieldOptions: {
    warehouses: TmsTaskFieldOption[];
    externalStations: TmsTaskFieldOption[];
    carriers: TmsTaskFieldOption[];
    handoverCarriers: TmsTaskFieldOption[];
    routes: TmsTaskFieldOption[];
    vehicles: TmsTaskFieldOption[];
    vehicleTypes: TmsTaskFieldOption[];
    drivers: TmsTaskFieldOption[];
    schedules: TmsTaskFieldOption[];
  };
};

export const TMS_TASK_FIELD_OPTIONS = gql`
  query OpsToolTmsTaskFieldOptions {
    opsToolTmsTaskFieldOptions {
      warehouses { value label }
      externalStations { value label }
      carriers { value label centerWarehouseIds }
      handoverCarriers { value label centerWarehouseIds }
      routes { value label routeName routeCode routeType startWarehouseId }
      vehicles { value label carrierId licensePlate vehicleTypeId }
      vehicleTypes { value label }
      drivers { value label phone carrierId }
      schedules { value label routeId }
    }
  }
`;
